<template>
  <div class="memberList">
    <v-card class="cardWrap">
      <CardTitle title="配信実績照会" />
      <v-form ref="form" lazy-validation>
          <v-toolbar flat color="white" class="mt-1">
                <v-text-field
                    class="mr-3 pt-4"
                    label="0000-00-00"
                    single-line
                    maxlength="10"
                    inputmode="tel"
                    type="tel"
                    @focus="focusDate(startDay)"
                    @input="startDay = $event"
                    :value="formatedDate(startDay)"
                    @keyup.delete="deleteKeyUpByStart($event)"
                    @keyup="startDay = formatDate(startDay)"
                    :rules="[
                        rules.string_type,
                        rules.format_date,
                        rules.correct_date
                    ]"
                />～
                <v-text-field
                    class="mr-3 ml-3 pt-4"
                    label="0000-00-00"
                    single-line
                    maxlength="10"
                    inputmode="tel"
                    type="tel"
                    @focus="focusDate(endDay)"
                    @input="endDay = $event"
                    :value="formatedDate(endDay)"
                    @keyup.delete="deleteKeyUpByEnd($event)"
                    @keyup="endDay = formatDate(endDay)"
                    :rules="[
                        rules.string_type,
                        rules.format_date,
                        rules.correct_date
                    ]"
                />
                <v-select
                    class="mr-3 selectWidth pt-4"
                    item-value="delivery_id"
                    item-text="delivery_name"
                    :items="deliveryItemList"
                    v-model="deliveryId"
                    label="配信種別"
                ></v-select>
                <v-select
                    class="mr-3 selectWidth pt-4"
                    :items="Itemlist"
                    item-value="golf_code"
                    item-text="golf_name"
                    v-model="golf_code"
                    label="ゴルフ場を選択"
                    v-if="modeStatus === 'user_div'"
                    :rules="[rules.required_golf_course]"
                ></v-select>
            <v-spacer></v-spacer>
            <v-btn
                class="mr-2"
                color="primary"
                v-on:click="clickSearch"
                :disabled="btn[0].isActive"
                >検索
            </v-btn>
          </v-toolbar>
        </v-form>
      <v-data-table
        :headers="headers"
        :items="desserts"
        hide-default-footer
        class="elevation-1"
        sort-by="memberNo">
        <template v-slot:top>
        </template>
        <template v-slot:[`item.Btn`]="{ item }">
          <v-btn color="green darken-4" text @click="OnOpenModal(item)" class="editBtn" :disabled="btn[1].isActive">詳細</v-btn>
        </template>
      </v-data-table>
      <v-pagination
        class="my-2"
        v-model="page"
        :length="pageCount"
        :total-visible="7"
        @input="clickPagination"
      ></v-pagination>
      <!-- <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-4" text @click="OnAddModal" :disabled="btn[2].isActive">追加</v-btn>
      </v-card-actions> -->
    </v-card>
    <ResultsModal
      ref="ResultsModal"
    />
  </div>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
import ResultsModal from './modal/ResultsModal';
import validater from '@/lib/validater';

import { MEMBER_LIST_INITIAL_DISPLAY } from '../../constants/member_list';
import { authorityMixin } from '@/views/authorityMixin';
import { utilityMixin } from '@/mixins/utility';
import { GET_OPERATION_ACCESSES_LIST } from '@/constants/operation_accesses';
import { GET_LOGIN_ADMIN } from '@/constants/login';
import { GET_DELIVERY_ACTUALS_NUMBER_LIST } from '@/constants/delivery_actuals';
import { GET_CODE_LIST } from '@/constants/codelist';
import { GET_DELIVERY_MASTER } from '@/constants/delivery_master';

export default {
    components: {
        CardTitle,
        ResultsModal
    },
    mixins: [
        authorityMixin,
        utilityMixin
    ],
    data () {
        return {
            page: 1,
            pageCount: 0,
            begin_row: 0,
            limit_rows: 10,
            startDay: '',
            endDay: '',
            deliveryItemList: [],
            deliveryTypeList: [],
            deliveryId: '',
            Itemlist: [],
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [
                { text: '配信日', sortable: false, value: 'delivery_date' },
                { text: '配信種別', align: 'left', sortable: false, value: 'delivery_name' },
                { text: '送信対象人数', align: 'right', sortable: false, value: 'executed_number_char' },
                { text: '送信実行人数', align: 'right', sortable: false, value: 'delivery_result_ok_char' },
                { text: '', value: 'Btn', sortable: false }
            ],
            // 区分選択のセレクトエリアの表示値
            golf_groups: [],
            // ゴルフ場選択の制御
            modeStatus: '',
            golf_code: null,
            golfSelect: [],
            process: {
                result: '',
                resultText: '',
                btnDisabled: 0
            },
            addOverlay: false,
            fromSetData: {
                delivery_id: '',
                delivery_date: '',
                delivery_contents: ''
            },
            date: '',
            // ログインしている者の情報
            admin: {
                golf_code: '',
                user_div: '',
                user_id: '',
                point_use_type: ''
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: '詳細', isActive: true }
            ],
            vue_id: 'SCR0108',
            rules: {
                string_type: value => validater.checkDateStringType(value) || this.$t('error.validation.num'),
                format_date: value => validater.checkDateFormat(value) || this.$t('error.validation.date.Correct'),
                correct_date: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct')
            }
        };
    },
    async created () {
        await this.$apollo.mutate({
            mutation: GET_LOGIN_ADMIN
        }).then(res => {
            this.admin.user_id = res.data.getLoginAdmin.user_id;
            this.admin.user_div = res.data.getLoginAdmin.login.user_div;
            this.admin.golf_code = res.data.getLoginAdmin.login.golf_code;
            return res.data.getLoginAdmin;
        });
        await this.initialFetch();

        this.admin.point_use_type = this.golf_groups[0].point_use_type;

        // システム管理者の場合
        if (this.admin.user_div === 1 && this.admin.point_use_type === 1) {
            this.Itemlist = [];
            this.Itemlist = this.golfSelect;
            this.golfSelect.unshift({ golf_code: '', golf_name: '' });
        } else if (this.admin.user_div === 1 && this.admin.point_use_type === 2) {
            this.Itemlist = [];
            this.Itemlist = this.golfSelect;
            this.golf_code = this.Itemlist[0].golf_code;
        } else {
        // ゴルフ場担当者
            this.Itemlist = [];
            this.Itemlist.push(this.golfSelect.find(el => el.golf_code === this.admin.golf_code));
            this.golf_code = this.admin.golf_code;
        }

        // this.deliveryTypeList = await this.getCodeList('delivery_type');
        // await this.getTemplateCode();
        await this.getDeliveryMasterList();
        this.getDeliveryList();
        // this.getMember();
        // this.getMessageList();
        await this.getAuthorityByMemberList();
    },
    computed: {
        formatedDate: function () {
            return function (pdate) {
                pdate = this.addHyphen(pdate);
                return pdate;
            };
        }
    },
    methods: {
        initialFetch () {
            return this.$apollo.mutate({
                mutation: MEMBER_LIST_INITIAL_DISPLAY,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE
                }
            }).then(res => {
                this.golfSelect = res.data.getGolfCourse;
                this.golf_groups = res.data.getGolfGroupByMaster;
            });
        },
        getAuthorityByMemberList () {
            this.$apollo.mutate({
                mutation: GET_OPERATION_ACCESSES_LIST,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    user_id: this.admin.user_id,
                    vue_id: this.vue_id,
                    element_id: ''
                }
            }).then(res => {
                let opeList = res.data.GetOperationAccessList.OperationAccessList;
                for (let list of opeList) {
                    this.btn.forEach(el => {
                        if (list.element_id === el.element_id) {
                            if (list.element_control === 0) {
                                el.isActive = true;
                            } else {
                                el.isActive = false;
                            }
                        }
                    });
                };
            });
        },
        /** --------------------------------------------
        * 連絡事項設定一覧取得
        * -------------------------------------------- */
        async getDeliveryList () {
            try {
                await this.$apollo
                    .mutate({
                        fetchPolicy: 'no-cache',
                        mutation: GET_DELIVERY_ACTUALS_NUMBER_LIST,
                        variables: {
                            start_day: this.startDay,
                            end_day: this.endDay,
                            delivery_id: this.deliveryId,
                            begin_row: this.begin_row,
                            limit_rows: this.limit_rows
                        }
                    })
                    .then(res => {
                        this.desserts = [];
                        this.desserts = res.data.getDeliveryActualsNumberList.DeliveryActualsNumberList;
                        this.pageCount = Math.ceil(res.data.getDeliveryActualsNumberList.count / this.limit_rows);
                    });
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * DeliveryMaster取得
         * ---------------------------------------------- */
        async getDeliveryMasterList () {
            try {
                await this.$apollo
                    .mutate({
                        fetchPolicy: 'no-cache',
                        mutation: GET_DELIVERY_MASTER,
                        variables: {
                            deliveryId: ''
                        }
                    })
                    .then(res => {
                        this.deliveryItemList = res.data.GetDeliveryMaster.DeliveryMasterList;
                        this.deliveryId = this.deliveryItemList[0].delivery_id;
                    });
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * コードリスト取得
         * ---------------------------------------------- */
        getCodeList (keyname) {
            return this.$apollo.query({
                query: GET_CODE_LIST,
                variables: {
                    code_key: keyname,
                    default_display: 0
                }
            }).then(res => {
                return res.data.GetCodeList.CodeList;
            });
        },
        /** ----------------------------------------------
        * 詳細ボタン押下時の処理
        * @item 子画面に渡すモーダル表示制御値
        * ---------------------------------------------- */
        OnOpenModal: function (item) {
            this.$refs.ResultsModal.OpenModal(item);
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUpByStart (event) {
            this.startDay = this.formatDate(this.startDay);
            this.startDay = this.deleteKeyDelete(event);
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUpByEnd (event) {
            this.endDay = this.formatDate(this.endDay);
            this.endDay = this.deleteKeyDelete(event);
        },
        clickPagination: function () {
            this.begin_row = this.page * this.limit_rows - this.limit_rows;
            this.getDeliveryList();
        },
        clickSearch: function () {
            if (this.$refs.form.validate()) {
                this.page = 1;
                this.begin_row = 0;
                this.getDeliveryList();
            }
        }
    }
};
</script>

<style scoped>
.point_select {
  color: black;
  background: Transparent;
  text-decoration: underline;
}

.selectWidth {
    width: 195px;
}

</style>
